// extracted by mini-css-extract-plugin
export default {"filterItemBadge":"ItemBadge_filterItemBadge__9utLc","removeButton":"ItemBadge_removeButton__8UEFT","badgeIcon":"ItemBadge_badgeIcon__lCthj"};